<template>
  <div>
    <SearchNavHeader :currentPage="'searchUsers'"/>
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col-12 text-center">
          <v-combobox
              v-if="showSearchBox"
              v-model="searchKeyWord"
              :items="usersListItems"
              :return-object="false"
              append-icon="far fa-search"
              class="rounded-lg search-combobox"
              clearable
              dense
              flat
              hide-details
              placeholder="جستجو در کاربران..."
              solo
              @keyup="search($event)"
              @click:clear="clearSearchHistory"
              @click:append="searchBtn"></v-combobox>
          <span v-else class=" rounded-xl bg-white py-2 px-3 d-inline-block position-relative">
             {{ searchKeyWord }}
             <v-btn class=" pl-1 close-search-key-btn" icon small @click="removeSearchKeyword"><i
                 class="fa-regular fa-circle-xmark pointer font16px "></i></v-btn>
          </span>
        </div>
      </div>
      <div class="min-height-300px">
        <div class="row">
          <div class="col-12">
            <div v-if="!hasResult" class="row mx-1">
              <div class="col-12 text-center">
                نتیجه ای یافت نشد
              </div>
            </div>
            <div v-for="(item,i) in users" v-else :key="i" class="row align-items-center">
              <router-link :to="{path:'ProfileInSite',query:{ID:item.AppUserID}}" class="col-2 ">
                <v-avatar size="50">
                  <img v-if="item.AppUser.FileUrl !== null" :src="$replaceHttps(item.AppUser.FileUrl)"
                       alt="تصویر کاربر">
                  <i v-else class="fas fa-circle-user fa-4x"></i>
                </v-avatar>
              </router-link>
              <div class="col-6">
                  <span class="font-weight-bold mr-1" dir="ltr"><i v-if="item.IsVerified"
                                                                   class="fa-solid fa-badge-check mr-1"></i>{{
                      item.AppUser.Name + ' ' + item.AppUser.Family
                    }}  </span>
                <div class="text-truncate font12px m-0 bio-text" v-html=" item.Bio"></div>
              </div>
              <div class="col-4">
                <v-btn :class="item.isFollow ? true :'black--text'" :color="item.isFollow ? 'primary':'white'"
                       block
                       class="rounded-lg" depressed
                       small @click.prevent.stop="followedUser(item.AppUserID,item)">
                  <span v-if="item.isFollow">دنبال شد</span>
                  <span v-else>دنبال کردن</span>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import SearchNavHeader from "@/views/Search/SearchNavHeader";

export default {
  name: "SearchUsers",

  metaInfo: {
    title: 'ایوان خانه- جستجوی کاربر',
  },
  components: {SearchNavHeader},
  data: () => ({
    showSearchBox: true,
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    searchKeyWord: '',
    users: [],
    usersListItems: [],
    hasResult: true,
    latestUsers: [],
    allUsers: [],
    latestUsersLoading: true
  }),

  mounted() {
    this.getUsersList()
    this.getUsersListToShow()
  },
  methods: {
    search(e) {
      if (e.keyCode === 13) {
        this.searchBtn()
      }
    },

    searchBtn() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("KeyWord", this.searchKeyWord);
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "SearchSocialNetwork/SearchClients", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.users = JSON.parse(result);
              this.showSearchBox = false
              this.hasResult = true

            } else {
              this.hasResult = false

            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    removeSearchKeyword() {
      this.showSearchBox = true
      this.searchKeyWord = null
      this.users = this.allUsers
    },
    clearSearchHistory() {
      this.hasResult = true
    },
    getUsersList() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      let urlencoded = new URLSearchParams();
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/SearchClients", requestOptions)
          .then(response => response.text())
          .then(result => {
            let users = JSON.parse(result)
            let items = []
            for (let i = 0; i < users.length; i++) {
              items.push(users[i].AppUser.Name + users[i].AppUser.Family)
            }
            this.usersListItems = items
          })
          .catch(error => console.log('error', error));


    },
    getUsersListToShow() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      let urlencoded = new URLSearchParams();
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/SearchClients", requestOptions)
          .then(response => response.text())
          .then(result => {
            let users = JSON.parse(result)
            let followings = this.$store.getters.getUserFollowings
            for (let i = 0; i < users.length; i++) {
              users[i].isFollow = followings.find(x => x.FollowedAppUserId === users[i].AppUserID) !== undefined;
            }
            this.users = users;
            this.allUsers = users

            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    followedUser(id, item) {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("FollowedAppUserId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              item.isFollow = !item.isFollow
              let payload = {id: id, type: 1}
              this.$store.commit('addOrRemoveFollowingItemToList', payload)
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    }

  }
}
</script>

<style scoped>

</style>
